
import Vue from 'vue'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {Component} from 'vue-property-decorator'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import {apiUrl} from '@/config/service'
import {namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'

const authModule = namespace('auth')
const prospectModule = namespace('prospect')
const documentModule = namespace('document')

@Component({
  components: {
    BaseCardContainer,
    vueDropzone
  }
})
export default class ProspectDocument extends Vue {
  @authModule.Getter('tokenGetter') token: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @documentModule.Action('downloadDocumentAction') downloadDocument: any
  @documentModule.Action('deleteDocumentAction') deleteDocument: any
  @prospectModule.Getter('prospectGetter') prospect: any
  dropzoneOptions = null

  $refs: {
    myVueDropzone: any
  }

  mounted() {
    this.dropzoneOptions = {
      url: `${apiUrl}/document/upload`,
      headers: {
        Authorization: `Bearer ${this.token}`
      },
      maxFilesize: 30
    }
  }

  getConvertedSize(size) {
    return size !== 0 ? `${Math.round(size / 1000)} Ko -` : null
  }

  getExt(filename) {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
  }

  sendFile(file, xhr, formData) {
    formData.append('ID_PROSPECT', this.$route.params.id)
  }

  onComplete(file) {
    this.$refs.myVueDropzone.removeFile(file)
  }

  onQueueComplete() {
    this.getProspectById(this.$route.params.id)
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du document ?', optionsVslim)
    if (ok) {
      this.deleteDocument(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }

  onDownload(item: any) {
    this.downloadDocument(item)
  }

  onError(file, data, xhr) {
    if (data.type === 'validation') {
      Vue.notify({
        group: 'user',
        type: 'warn',
        title: 'Validation des champs',
        text: data.validations.message
      })
    }
  }
}
